import { env } from "@canucci/base/env";
import { AuthProvider } from "@canucci/base/auth";
import { auth } from "@/firebaseConfig";
import { User } from "firebase/auth";
import { authenticate } from "@/services/api";
import { Outlet, useSearchParams } from "react-router-dom";
import MfaRefusalBoundary from "@/components/layout/MfaRefusalBoundary";

export default function AuthLayout() {
  const [searchParams] = useSearchParams();

  const authenticateFirebaseUser = async (user: User) => {
    const isJustVerified = searchParams.get("verified") === "true";
    const idToken = await user.getIdToken(isJustVerified); // Pass `true` to force a refresh
    return authenticate(idToken);
  };

  return (
    <AuthProvider
      auth={auth}
      authenticateFirebaseUser={authenticateFirebaseUser}
      googleClientId={env.VITE_GOOGLE_CLIENT_ID ?? ""}
    >
      <MfaRefusalBoundary>
        <Outlet />
      </MfaRefusalBoundary>
    </AuthProvider>
  );
}
